import * as React from 'react';
import { UserContext } from '../Context/UserContext';
import { UserFlagRepository } from '../../MedicareProAPI/Repositories/User/UserFlagRepository';

export interface IndFlagRendererProps {
  value: string;
}

export const IndFlagRenderer = (props: IndFlagRendererProps): string => {
  const [renderedValue, setRenderedValue] = React.useState<string>(null);
  const [value, setValue] = React.useState<string>(props.value);

  const userData = React.useContext(UserContext);

  const userFlagRepository = new UserFlagRepository();
  userFlagRepository.setAccessToken(userData.userAccessToken);

  React.useEffect(() => {
    userFlagRepository.getUserFlagByColor(userData.userId, value).then((individualFlag) => {
      setRenderedValue(individualFlag.getFlagMeaning());
    });
  }, []);

  return renderedValue || value;
};
